// @flow
import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";

export const MessageContainer = styled.div`
  height: auto;
  min-height: 56px;
  max-height: 90px;
  padding: 16px;
  font-size: 12px;
  background: ${buildColor("white", "100")};
  display: flex;
  width: 190px;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
  position: relative;
  border-radius: 2px;
  flex-grow: 1;
  margin-right: 8px;
  align-self: flex-end;
  margin-bottom: 8px;

  &::after {
    content: "";
    width: 0;
    height: 0;
    left: -15px;
    border-top: 15px solid transparent;
    border-bottom: 0 solid transparent;
    border-right: 15px solid ${buildColor("white", "100")};
    position: absolute;
  }

  & p {
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export const TalentConfirmationHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const Image = styled.img`
  width: 120px;
  height: auto;
`;

export default {
  MessageContainer,
  TalentConfirmationHeader,
  Image
};
